import React, { useEffect } from "react";
import { DeleteElement } from "./DeleteElement";
import { Duplicate } from "./Duplicate";
import { LockElement } from "./LockElement";
import { FontFamily } from "./Text/FontFamily";
import { FontSize } from "./Text/FontSize";
import { FontStyle } from "./Text/FontStyle";
import { Position } from "./Text/Position";
import { TextCaseControl } from "./Text/TextCaseControl";
import { TextColor } from "./Text/TextColor";
import { Transparency } from "./Text/Transparency";
import { SaveContinue } from "./SaveContinue";
import { useParams } from "react-router-dom";
import { ElementStrokColor } from "./ElementStrokColor";
import { FlipPosition } from "./FlipPosition";
import { Layer } from "./Text/Layer";
import { Crop } from "./Crop";
import { ImageToolbar } from "./ImageToolbar";
import { BulletPointStyle } from "./BulletPointStyle";

export function ToolBar(editor) {
	const { createID, updateID } = useParams();
	const {
    Canvaseditor,
    disabledObj,
    setdisabledObj,
    showTextToolbar,
    elementStrokColor,
    showUploadToolbar,
    setLockObj,
    LockObj,
    canvases,
    canvasObjects,
    toolbarVisible = true,
  } = editor;

	// Re-attach selection/toolbar state when canvas instance changes (e.g. template change).
	// Without this, the new canvas never gets selection:created/cleared, so effect tools stay hidden.
	useEffect(() => {
		if (!Canvaseditor || !Canvaseditor.contextContainer) return;

		setdisabledObj(true);

		const onModified = function (event) {
			if (event.target && typeof event.target.text !== "undefined") {
				event.target.fontSize *= event.target.scaleX;
				event.target.fontSize = event.target.fontSize.toFixed(0);
				event.target.scaleX = 1;
				event.target.scaleY = 1;
				event.target._clearCache();
				if (document.getElementById("text-font-size")) {
					document.getElementById("text-font-size").value =
						event.target.fontSize;
				}
				let activeTextObject = Canvaseditor.getActiveObject();
				if (activeTextObject) {
					activeTextObject.set("fontSize", event.target.fontSize);
					Canvaseditor.renderAll();
				}
			}
		};

		const onSelectionCreated = function () {
			setdisabledObj(false);
		};

		const onSelectionCleared = function () {
			setdisabledObj(true);
		};

		Canvaseditor.on("object:modified", onModified);
		Canvaseditor.on("selection:created", onSelectionCreated);
		Canvaseditor.on("selection:cleared", onSelectionCleared);

		return function cleanup() {
			if (Canvaseditor && typeof Canvaseditor.off === "function") {
				Canvaseditor.off("object:modified", onModified);
				Canvaseditor.off("selection:created", onSelectionCreated);
				Canvaseditor.off("selection:cleared", onSelectionCleared);
			}
		};
	}, [Canvaseditor]);

	return (
    <nav
      className="bp4-navbar"
      style={{ display: toolbarVisible ? "flex" : "none" }}
    >
      <div className="bp4-navbar-group bp4-align-left">
        {!disabledObj && (
          <>
            {showUploadToolbar && <FlipPosition Canvaseditor={Canvaseditor} />}
            {elementStrokColor && (
              <>
                <ElementStrokColor Canvaseditor={Canvaseditor} />
                <ImageToolbar canvas={Canvaseditor} />
              </>
            )}
            {showTextToolbar && (
              <>
                <TextColor Canvaseditor={Canvaseditor} />
                <FontFamily Canvaseditor={Canvaseditor} />
                <FontSize Canvaseditor={Canvaseditor} />
                <TextCaseControl Canvaseditor={Canvaseditor} disabledObj={disabledObj} />
                <FontStyle Canvaseditor={Canvaseditor} />
                <BulletPointStyle Canvaseditor={Canvaseditor} />
              </>
            )}
          </>
        )}

        <Position Canvaseditor={Canvaseditor} disabledObj={disabledObj} />
        <Layer Canvaseditor={Canvaseditor} disabledObj={disabledObj} />
        <Transparency Canvaseditor={Canvaseditor} disabledObj={disabledObj} />

        <LockElement
          Canvaseditor={Canvaseditor}
          setdisabledObj={setdisabledObj}
          setLockObj={setLockObj}
          LockObj={LockObj}
        />
        <Duplicate Canvaseditor={Canvaseditor} disabledObj={disabledObj} />
        {showUploadToolbar && (
          <>
            <Crop Canvaseditor={Canvaseditor} disabledObj={disabledObj} />
            <ImageToolbar canvas={Canvaseditor} />
          </>
        )}
        <DeleteElement
          Canvaseditor={Canvaseditor}
          setdisabledObj={setdisabledObj}
          disabledObj={disabledObj}
        />
      </div>
      {(createID || updateID) && (
        <SaveContinue
          updateID={updateID}
          createID={createID}
          canvases={canvases}
          canvasObjects={canvasObjects}
        />
      )}
    </nav>
  );
}
